export default {
  not_set_up: {
    title: 'Rezervările nu sunt încă configurate pentru această locație',
    description:
      'O locație primește rezervări odată ce este conectată la înregistrarea sa Google și are un proprietar. Dacă restaurantul nu are încă un proprietar, adăugați unul în Echipă. Până atunci, nu există ore de funcționare pentru rezervări de editat aici, iar modificările orelor Online Shop nu sunt copiate în Rezervări.',
  },
  company_not_loaded: {
    title: 'Setările rezervărilor nu au putut fi încărcate',
    description:
      'Setările de rezervare ale acestei locații nu au putut fi încărcate, deci programul de funcționare pentru rezervări nu poate fi editat acum. Încearcă din nou.',
    retry: 'Încearcă din nou',
  },
};
